import { v_InventoryBus } from "./v_InventoryBus";
import { CommonFunctions } from "../static/common-functions";
import { BusinessObjectFactory } from "./BusinessObjectFactory";
import { GItem } from "./GItem";
import { QILineItemBus } from "./QILineItem";
import { DateTimePickerActiveTab } from "@progress/kendo-angular-dateinputs";
import { CommonValues } from "../static/CommonValues";

export class BaseBus {
    constructor(busObj: any = null, setEmptyGuidToNull: boolean = true) {
        this.setEmptyGuidToNull = setEmptyGuidToNull;
        if (busObj != undefined && busObj != null) {
            this.initialize(busObj);
        }
    }
    setEmptyGuidToNull: boolean = true;
    setEmptyStringGuidToNull: boolean = false;
    initialize(busObj: any) {
        Object.assign(this, busObj);
        this.setAdditional(busObj);
        if (this.setEmptyGuidToNull) {
            for (let property in this) {
                if (this[property] && this[property].toString() == CommonValues.Guid_Empty) {
                    this[property] = null;
                }
            }
            
        }
    }

    setNew(userId: any, date: Date, companyId: any = null, personId: any = null, parentId: any = null, other: any = null) {

    }
    protected setAdditional(busObj: any) {

    }
    setCommon(userId: any, date: Date, companyId: any = null, personId: any = null) {

    }
    setBeforeSave() {
        if (this.setEmptyStringGuidToNull) {
            for (let property in this) {
                if (property.toLowerCase().endsWith("id") && !this[property]) {
                    this[property] = null;
                }
            }
        }
    }

    setFromForm(busObj: any) {
        this.initialize(busObj);
    }
    CID(): any {
        return null;
    }
    get CUpdateDate(): Date {
        return null;
    }
    set CUpdateDate(value: Date) { }
    get usesOrderValue(): boolean {
        return false;
    }
    set usesOrderValue(value: boolean) { }
    get hasOrderValue(): boolean {
        return CommonFunctions.hasNumberValue(this.orderValue);
    }
    get orderValue(): number {
        return 0;
    }
    set orderValue(value: number) {

    }
    clear() {

    }
    setId(id: any) {

    }
    setParentId(id: any) {

    }
    setInventoryLine(data: QILineItemBus) {
    }
    changeInventoryItem(data: any) {
    }
    get hasId(): boolean {
        return this.CID() !== undefined && this.CID() !== null;
    }
    set hasId(value: boolean) {
        //nothing to set
    }
    isValid(): boolean {
        return true;
    }
    public static strIsEmpty(str: string): boolean {
        return str ? (str.replace(/\s/g, "").length > 0 ? false : true) : true;
    }
    public static setSearch(target: Object, search: string): void {
        //for (let [key, value] of Object.entries(target)) {
        //  if (key === "invoiceDesc") {
        //    let pos = value.indexOf(search);

        //    if (pos >= 0) {
        //      //target[key] = value.replace(search, "<span class='grid-search-highlight'>" + search + "</span>");
        //      target[key] = value.replace(search, "<span style='background-color: red'>" + search + "</span>");
        //    }
        //  }
        //}
    }
    get inFinance(): boolean {
        return false;
    }
    set inFinance(value: boolean) { }
    isUpdated: boolean;
    isAdded: boolean;
    deletedItems: GItem[] = [];
    customValue: any;
    addDeletedItem(delObj: GItem) {
        this.deletedItems.push(delObj);
    }
    addDeletedItems(delObjs: GItem[]) {
        if (CommonFunctions.hasArrayElementValue(delObjs)) {
            for (let i = 0; i < delObjs.length; i++) {
                this.addDeletedItem(delObjs[i]);
            }
        }
    }
    get canEdit(): boolean { return true; }
    set canEdit(value: boolean) { } //so doesnt cause errors when auto copying with Object
}
